import $ from '../../shared/zmp-dom';
import { extend } from '../../shared/utils';
import ListIndex from './list-index-class';
import ConstructorMethods from '../../shared/constructor-methods';

export default {
  name: 'listIndex',
  static: {
    ListIndex,
  },
  create() {
    const app = this;
    app.listIndex = ConstructorMethods({
      defaultSelector: '.list-index',
      constructor: ListIndex,
      app,
      domProp: 'zmpListIndex',
    });
  },
  on: {
    tabMounted(tabEl) {
      const app = this;
      $(tabEl)
        .find('.list-index-init')
        .each((listIndexEl) => {
          const params = extend($(listIndexEl).dataset(), { el: listIndexEl });
          app.listIndex.create(params);
        });
    },
    tabBeforeRemove(tabEl) {
      $(tabEl)
        .find('.list-index-init')
        .each((listIndexEl) => {
          if (listIndexEl.zmpListIndex) listIndexEl.zmpListIndex.destroy();
        });
    },
    pageInit(page) {
      const app = this;
      page.$el.find('.list-index-init').each((listIndexEl) => {
        const params = extend($(listIndexEl).dataset(), { el: listIndexEl });
        app.listIndex.create(params);
      });
    },
    pageBeforeRemove(page) {
      page.$el.find('.list-index-init').each((listIndexEl) => {
        if (listIndexEl.zmpListIndex) listIndexEl.zmpListIndex.destroy();
      });
    },
  },
  vnode: {
    'list-index-init': {
      insert(vnode) {
        const app = this;
        const listIndexEl = vnode.elm;
        const params = extend($(listIndexEl).dataset(), { el: listIndexEl });
        app.listIndex.create(params);
      },
      destroy(vnode) {
        const listIndexEl = vnode.elm;
        if (listIndexEl.zmpListIndex) listIndexEl.zmpListIndex.destroy();
      },
    },
  },
};
